module.exports = __webpack_public_path__ + "static/media/btn_visitors_1075_725.cf42216a.png";